import type { ElementType } from "react";
import { StatCard, type StatCardAccent } from "@/components/shared/StatCard";

interface DashboardStatCardProps {
  title: string;
  value: number | undefined;
  subtitle?: string;
  icon: ElementType;
  accent?: StatCardAccent;
  isLoading?: boolean;
  to?: string;
}

export function DashboardStatCard({
  title,
  value,
  subtitle,
  icon,
  accent = "primary",
  isLoading,
  to,
}: DashboardStatCardProps) {
  return (
    <StatCard
      label={title}
      value={value}
      sub={subtitle}
      icon={icon}
      accent={accent}
      isLoading={isLoading}
      to={to}
    />
  );
}
